import { render, staticRenderFns } from "./Fights.vue?vue&type=template&id=d9289f94&"
import script from "./Fights.vue?vue&type=script&lang=js&"
export * from "./Fights.vue?vue&type=script&lang=js&"
import style0 from "./Fights.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports